// extracted by mini-css-extract-plugin
export default {"container":"_1y0B0aRqtSCy7xJ3BsDEJC"};